import React from 'react';
import { PencilIcon } from 'lucide-react';

import { cn } from '@epoch-ui/lib/utils';
import { Button } from '@epoch-ui/components/Button';
import { EventType } from 'types/event.types';
import {
  EventInfo,
  EventInfoAddress,
  EventInfoVirtualLink,
  EventInfoPrivacy,
  EventInfoTeam,
  EventInfoLocation
} from '@epoch-components/EventInfo';
import { useEditableEvent } from 'pages/dashboard/overview/events/editor/hooks/useEditableEvent';
import { useEditEventDetailsSheet } from 'pages/dashboard/overview/events/editor/hooks/eventEditorState';

const EditEventBasicDetails = (): React.ReactElement => {
  const event = useEditableEvent();
  const editEventDetailsSheetState = useEditEventDetailsSheet();

  const isCancelled = !!event.scheduledDeletionAt;

  const isDisabled = event.hasEnded || isCancelled;
  const isMultiSessionParent = event.eventType === EventType.MULTI_SESSIONS;

  return (
    <div className={cn(isDisabled && 'tw-opacity-40')}>
      <div className="tw-mb-4 tw-flex tw-items-center tw-justify-between">
        <h2 className="tw-m-0 tw-text-xl tw-font-medium tw-leading-7">Overview</h2>
        <Button
          variant="secondary"
          size="xxs"
          className="tw-rounded-xl disabled:tw-opacity-100"
          disabled={isDisabled}
          onClick={() => editEventDetailsSheetState.open()}
        >
          <PencilIcon size={16} className="tw-mr-1" />
          Edit event
        </Button>
      </div>
      <EventInfo event={event}>
        {!isMultiSessionParent && <EventInfoAddress />}
        <EventInfoVirtualLink />
        <EventInfoPrivacy />
        <EventInfoTeam />
        <EventInfoLocation />
      </EventInfo>
    </div>
  );
};

export { EditEventBasicDetails };
